export default {
    includes (text, search) {
        if (!text) {
            return false;
        }

        return text.toUpperCase().includes(search.toUpperCase())
    },

    startsWith (text, search) {
        if (!text || !search) {
            return false;
        }

        return text.toUpperCase().startsWith(search.toUpperCase())
    }
}